module.exports = __webpack_public_path__ + "img/45c6c26d0344503188890a8628d9804d.9cee7625.jpeg";